;(() => {
  const dropdowns = document.querySelectorAll(
    'footer#footer button.dropdown-toggle'
  )

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('click', () => {
      dropdown.classList.toggle('active')
      const panel = dropdown.nextElementSibling
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px'
      }
    })
  })
})()
